import { useRef } from "react";
import { categoriesData } from "src/data/staticData";
import useSlider from "src/hooks/App/useSlider";
import SliderButtons from "../../shared/midcomponents/productslider/SliderButtons";

import CategoryCard from "../../shared/productcard/CategoryCard/CategoryCard";

import s from "./CategoriesSlider.module.scss";

const CategoriesSlider = () => {
  const sliderRef = useRef();
  const { handleNextBtn, handlePrevBtn } = useSlider(sliderRef);

  return (
    <>
      <SliderButtons
        handlePrevBtn={handlePrevBtn}
        handleNextBtn={handleNextBtn}
      />

      <div className={s.categoriesSlider} ref={sliderRef}>
        {categoriesData.map((categoryData) => (
          <CategoryCard categoryData={categoryData} key={categoryData.id} />
        ))}
      </div>
    </>
  );
};
export default CategoriesSlider;
